<template>
  <app-success-modal :modalActive="modalActives" @close="toggleModal()" :countdown="countdown"></app-success-modal>

  <div class="right-banner-template-container">
    <div class="ui-content">
      <div class="title">
        <h3>{{ getSubMenuInfo.name }}</h3>
        <img @contextmenu.prevent src="../../assets/title-line.png">
      </div>
      <div class="application-content">
        <form @submit.prevent="submitForm">
          <div class="form-header">
            <h2>{{ labelFormData.title }}</h2>
            <p>{{ labelFormData.sub1 }}</p>
            <p>{{ labelFormData.sub2 }}</p>
          </div>
          <div class="form-body">
            <span>{{ labelFormData.selfInfo }}</span>
            <div class="form-control muti-data" :class="{invalid: !name.isValid}">
              <div class="data-input">
                <label for="name">{{ labelFormData.name }}<span class="mark">*</span></label>
                <input type="text" v-model.trim="formData.fullName" @blur="clearValidity('name')">
                <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
              </div>
              <div class="data-input">
                <label>{{ labelFormData.gender }}<span class="mark">*</span></label>
                <div style="display: flex; gap: 0 40px; margin-top: 8px;">
                  <label style="display: flex; align-items: center;">
                    <input id="cb" type="radio" :value="true" v-model="formData.gender"
                      style="margin-right: 20px; width: 20px; margin-top: 0px;" />
                    {{ labelFormData.male }}
                  </label>
                  <label style="display: flex; align-items: center;">
                    <input id="cb" type="radio" :value="false" v-model="formData.gender"
                      style="margin-right: 20px; width: 20px; margin-top: 0px;" />
                      {{ labelFormData.female }}
                  </label>
                </div>
                <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
              </div>
            </div>
            <div class="form-control" :class="{invalid: !cccd.isValid}">
              <label>{{ labelFormData.birthday }}<span class="mark">*</span></label>
              <!-- <p class="formated-date">{{ birthdayValue }}</p> -->
              <input type="text" id="date-input" placeholder="dd/mm/yyyy" v-model="birthdayInputValue" @blur="validateDateInput">
              <input type="date" v-model="formData.birthday" @keydown.prevent @input="shareBirthdayValue" min="1950-01-01" max="2059-12-31">
            </div>
            <!-- blank -->
            <!-- <div class="form-control muti-data" :class="{invalid: !name.isValid}">
              <div class="data-input">
                <label>{{ labelFormData.birthday }}<span class="mark">*</span></label>
                <p class="formated-date">{{ birthdayValue }}</p>
                <input type="date" v-model="formData.birthday" @keydown.prevent>
                <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
              </div>
              <div class="data-input">
                <label>{{ labelFormData.age }}<span class="mark">*</span></label>
                <input type="number" v-model.trim="formData.age" @blur="clearValidity('name')">
                <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
              </div>
            </div> -->
            <div class="form-control" :class="{invalid: !cccd.isValid}">
              <label>{{ labelFormData.birthPlace }}<span class="mark">*</span></label>
              <input type="text" v-model.trim="formData.birthPlace" @blur="clearValidity('name')">
              <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
            </div>
            <div class="form-control" :class="{invalid: !cccd.isValid}">
              <label>{{ labelFormData.permanentRes }}<span class="mark">*</span></label>
              <input type="text" v-model.trim="formData.permanentAddress" @blur="clearValidity('name')">
              <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
            </div>
            <div class="form-control" :class="{invalid: !cccd.isValid}">
              <label>{{ labelFormData.citizenIdentificationCard }}<span class="mark">*</span></label>
              <input type="text" v-model.trim="formData.citizenIdentificationCard" @blur="clearValidity('name')">
              <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
            </div>
            <div class="form-control muti-data" :class="{invalid: !name.isValid}">
              <div class="data-input">
                <label>{{ labelFormData.dateOfIssue }}<span class="mark">*</span></label>
                <!-- <p class="formated-date">{{ dateOfIssueValue }}</p> -->
                <input type="text" id="date-input" placeholder="dd/mm/yyyy" v-model="issueInputValue" @blur="validateIssueDateInput">
                <input type="date" v-model="formData.dateOfIssue" @keydown.prevent @input="shareIssueDateValue" min="1950-01-01" max="2059-12-31">
                <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
              </div>
              <div class="data-input">
                <label>{{ labelFormData.placeOfIssue }}<span class="mark">*</span></label>
                <input type="text" v-model.trim="formData.placeOfIssue" @blur="clearValidity('name')">
                <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
              </div>
            </div>
            <div class="form-control muti-data" :class="{invalid: !name.isValid}">
              <div class="data-input">
                <label>{{ labelFormData.phoneNum }}<span class="mark">*</span></label>
                <input type="text" v-model.trim="formData.phoneNumber" @blur="clearValidity('name')">
                <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
              </div>
              <div class="data-input">
                <label>{{ labelFormData.email }}<span class="mark">*</span></label>
                <input type="text" v-model.trim="formData.email" @blur="clearValidity('name')">
                <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
              </div>
            </div>
            <div class="form-control muti-data" :class="{invalid: !name.isValid}">
              <div class="data-input">
                <label>{{ labelFormData.eduLevel }}<span class="mark">*</span></label>
                <input type="text" v-model.trim="formData.educationLevel" @blur="clearValidity('name')">
                <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
              </div>
              <div class="data-input">
                <label>{{ labelFormData.englishCertificate }}<span class="mark">*</span></label>
                <!-- <input type="text" v-model.trim="formData.englishCertificate" @blur="clearValidity('name')"> -->
                <select v-model="formData.englishCertificate">
                  <option value="IELTS">IELTS</option>
                  <option value="TOEIC">TOEIC</option>
                </select>
                <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
              </div>
            </div>
            <!-- <div class="form-control" :class="{invalid: !cccd.isValid}">
              <label>{{ labelFormData.eduLevel }}</label>
              <input type="text" v-model.trim="formData.educationLevel" @blur="clearValidity('name')">
              <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
            </div> -->
            <!-- <div class="form-control" :class="{invalid: !cccd.isValid}">
              <label>{{ labelFormData.expertLevel }}</label>
              <input type="text" v-model.trim="formData.professionalLevel" @blur="clearValidity('name')">
              <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
            </div>
            <div class="form-control muti-data" :class="{invalid: !name.isValid}">
              <div class="data-input">
                <label>{{ labelFormData.englishScore }}</label>
                <input type="text" v-model.trim="formData.englishScore" @blur="clearValidity('name')">
                <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
              </div>
              <div class="data-input">
                <label>{{ labelFormData.expiredDate }}</label>
                <p class="formated-date">{{ expirationDateValue }}</p>
                <input type="date" v-model="formData.expirationDate" @blur="clearValidity('name')">
                <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
              </div>
            </div> -->

            <!-- Family Info -->
            <span>{{ labelFormData.familyInfo }}</span>
            <div class="form-control muti-data" :class="{invalid: !name.isValid}">
              <div class="data-input">
                <label>{{ labelFormData.fatherName }}<span class="mark">*</span></label>
                <input type="text" v-model.trim="formData.fatherName" @blur="clearValidity('name')">
                <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
              </div>
              <div class="data-input">
                <label>{{ labelFormData.familyBirthYear }}<span class="mark">*</span></label>
                <input type="number" v-model.trim="formData.fatherBirthYear" @blur="clearValidity('name')">
                <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
              </div>
            </div>
            <div class="form-control muti-data" :class="{invalid: !name.isValid}">
              <div class="data-input">
                <label>{{ labelFormData.motherName }}<span class="mark">*</span></label>
                <input type="text" v-model.trim="formData.motherName" @blur="clearValidity('name')">
                <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
              </div>
              <div class="data-input">
                <label>{{ labelFormData.familyBirthYear }}<span class="mark">*</span></label>
                <input type="number" v-model.trim="formData.motherBirthYear" @blur="clearValidity('name')">
                <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
              </div>
            </div>
            <div class="form-control" :class="{invalid: !cccd.isValid}">
              <label>{{ labelFormData.parentPhoneNum }}<span class="mark">*</span></label>
              <input type="text" v-model.trim="formData.parentPhoneNum" @blur="clearValidity('name')">
              <p v-if="!name.isValid" style="color: red;">{{ formData.errName }}</p>
            </div>

            <div class="form-control">
              <span>{{ labelFormData.attachments }}</span><span class="mark">*</span>
              <!-- Loop through the file input list -->
              <div v-for="(file, index) in fileList" :key="index" style="margin: 15px 0px;">
                <div style="display: flex; align-items: center;" >
                  <!-- <label>{{ labelFormData.file1 }}</label> -->
                  <label>{{ getFileLabel(index) }} </label>
                  <div class="tooltip" v-if="getNotice(index) !== ''">
                    <i class="fa-solid fa-circle-info"></i>
                    <span class="tooltiptext">{{ getNotice(index) }}</span>
                  </div>
                  <!-- <label>{{ file.title }}</label> -->
                  <label v-if="file.eg" style="margin-left: 5px;">
                     ( {{ labelFormData.sample }}
                    <a :href="file.eg" target="_blank" :download="file.title">
                      <i class="fa-solid fa-download" style="color: #0076bb;"></i></a>)
                  </label>
                </div>

                <div class="muti-data" style="margin-top: 0.5rem;">
                  <!-- File Upload -->
                  <div class="data-input-file">
                    <input
                      type="file"
                      @change="changeFile($event, index)"
                      :id="'file-' + index"
                    />
                    <label :for="'file-' + index"><i class="fa-solid fa-upload"></i>Upload File</label>
                  </div>

                  <!-- Display File Name and Extension -->
                  <div class="data-input" style="padding-top: 5px;">
                    <div class="file-info-box">
                      <a
                        v-if="file.url"
                        :href="file.url"
                        :download="file.name"
                        class="file-link"
                      >
                        <img @contextmenu.prevent :src="require(`../../assets/fileType/${getFileType (file.extension)}`)">
                        {{ truncatedFileName(file.name) }}
                      </a>
                      <span v-if="file.size" style="color: black; font-weight: normal; font-size: 14px; margin-left: 5px">({{ file.size }})</span>
                      <!-- {{ file.name ? `${file.name}` : "" }} -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="display: flex; justify-content: center;">
              <button :class="{ loading: isLoading }" :disabled="isLoading">
                <p class="btn-text">{{ labelFormData.submit }}</p>
              </button>
            </div>
            <div class="g-recaptcha" style="margin-top: 10px; justify-content: center; display: flex;" data-sitekey="6LdIQlwqAAAAAPyKKmSZUIBPiAYoLs18FbV_Fdk4"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['subMenu'],
  data () {
    return {
      fileList: [
        { title: 'Đơn xin dự tuyển', name: '', url: '', extension: '', eg: '/PublicDocuments/ĐƠN XIN ĐĂNG KÝ DỰ TUYỂN.docx' },
        { title: 'Bản khai lý lịch', name: '', url: '', extension: '', eg: '/PublicDocuments/BẢN TÓM TẮT LÝ LỊCH.doc' },
        { title: 'Giấy khai sinh', name: '', url: '', extension: '', eg: '' },
        { title: 'Bằng Tốt nghiệp', name: '', url: '', extension: '', eg: '' },
        { title: 'Phiếu điểm tiếng Anh', name: '', url: '', extension: '', eg: '' },
        { title: 'Hộ chiếu và CCCD Học viên', name: '', url: '', extension: '', eg: '' },
        { title: 'CCCD người bảo lãnh', name: '', url: '', extension: '', eg: '' },
        { title: 'Ảnh 4x6 và 3x4', name: '', url: '', extension: '', eg: '' },
        { title: 'Phiếu khám sức khỏe', name: '', url: '', extension: '', eg: '' },
        { title: 'Lý lịch tư pháp', name: '', url: '', extension: '', eg: '' }
      ], // List of 4 objects for 4 inputs
      formData: {
        fullName: null,
        gender: true,
        birthday: null,
        age: 0,
        birthPlace: null,
        permanentAddress: null,
        citizenIdentificationCard: null,
        placeOfIssue: null,
        dateOfIssue: null,
        phoneNumber: null,
        email: null,
        educationLevel: null,
        englishCertificate: null,
        fatherName: null,
        motherName: null,
        fatherBirthYear: null,
        motherBirthYear: null,
        parentPhoneNum: null
      },
      isLoading: false,
      isFormValid: true,
      errorMess: '',
      initialFormData: null,
      maxLengthTruncated: 20,
      selectedFiles: [],
      birthdayInputValue: '',
      issueInputValue: '',
      modalActives: false,
      countdown: 5,
      intervalId: null,
      name: {
        val: '',
        isValid: true
      },
      cccd: {
        val: '',
        isValid: true
      },
      address: {
        val: '',
        isValid: true
      },
      formIsValid: true
    }
  },
  mounted () {
    this.initialFormData = JSON.parse(JSON.stringify(this.formData))
    this.updateMaxLength()
    window.addEventListener('resize', this.updateMaxLength)

    // this.$store.state.isLoggedIn = false
    // Dynamically load the Google reCAPTCHA script when the component is mounted
    const scriptId = 'recaptcha-script'
    // console.log('Google reCAPTCHA .')
    const script = document.createElement('script')
    script.src = 'https://www.google.com/recaptcha/api.js'
    script.async = true
    script.defer = true
    script.id = scriptId // To avoid duplicate script load
    document.head.appendChild(script)
  },
  computed: {
    getSubMenuInfo () {
      return this.$store.getters['navbar/findSubMenus1'](this.subMenu)
    },
    labelFormData () {
      return this.$store.getters['recruit/labelFormData']
    },
    birthdayValue () {
      if (!this.formData.birthday) return 'dd/mm/yyyy'
      const [year, month, day] = this.formData.birthday.split('-')
      return `${day}/${month}/${year}`
    },
    dateOfIssueValue () {
      if (!this.formData.dateOfIssue) return 'dd/mm/yyyy'
      const [year, month, day] = this.formData.dateOfIssue.split('-')
      return `${day}/${month}/${year}`
    }
  },
  watch: {
    modalActives (newVal) {
      if (newVal) {
        this.startCountdown()
      }
    }
  },
  methods: {
    startCountdown () {
      this.countdown = 5
      this.intervalId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          clearInterval(this.intervalId)
          this.$router.push('/')
        }
      }, 1000)
    },
    // Birthdate
    validateDateInput () {
      if (!this.birthdayInputValue) {
        this.formData.birthday = ''
        return
      }
      const regex = /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[0-2])\/(19[5-9][0-9]|20[0-5][0-9])$/
      if (!regex.test(this.birthdayInputValue)) {
        this.$showError('Ngày sinh sai định dạng')
        this.formData.birthday = ''
        this.birthdayInputValue = ''
        return
      }

      const [day, month, year] = this.birthdayInputValue.split('/').map(Number)
      this.birthdayInputValue = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`

      this.formData.birthday = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
    },
    shareBirthdayValue () {
      const [year, month, day] = this.formData.birthday.split('-').map(Number)
      this.birthdayInputValue = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`
    },
    // Date of Issue
    validateIssueDateInput () {
      if (!this.issueInputValue) {
        this.formData.dateOfIssue = ''
        return
      }
      const regex = /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[0-2])\/(19[5-9][0-9]|20[0-5][0-9])$/
      if (!regex.test(this.issueInputValue)) {
        this.$showError('Ngày cấp sai định dạng')
        this.formData.dateOfIssue = ''
        this.issueInputValue = ''
        return
      }

      const [day, month, year] = this.issueInputValue.split('/').map(Number)
      this.issueInputValue = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`

      this.formData.dateOfIssue = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
    },
    shareIssueDateValue () {
      const [year, month, day] = this.formData.dateOfIssue.split('-').map(Number)
      this.issueInputValue = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`
    },
    clearValidity (input) {
      this[input].isValid = true
    },
    truncatedFileName (name) {
      if (name.length > this.maxLengthTruncated) {
        return name.slice(0, this.maxLengthTruncated) + '...'
      }
      return name
    },
    changeFile (event, index) {
      const file = event.target.files[0]
      if (file) {
        // Update the object in the list at the specified index
        const formatFileSize = (size) => {
          if (size < 1024) return `${size} B` // Bytes
          if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB` // Kilobytes
          return `${(size / (1024 * 1024)).toFixed(2)} MB` // Megabytes
        }

        this.fileList[index] = {
          title: this.fileList[index].title,
          name: file.name,
          url: URL.createObjectURL(file),
          size: formatFileSize(file.size),
          extension: '.' + file.name.split('.').pop().toLowerCase(),
          eg: this.fileList[index].eg,
          file: file
        }
      } else {
        // Reset the object if no file is chosen
        this.fileList[index] = { title: this.fileList[index].title, name: '', url: '', extension: '', eg: this.fileList[index].eg, size: '', file: null }
      }
    },
    getFileLabel (index) {
      return this.labelFormData[`file${index + 1}`]
    },
    getNotice (index) {
      return this.labelFormData[`tip${index + 1}`]
    },
    getFileType (type) {
      if (type === '.pdf') return 'pdf.png'
      else if (type === '.xlsx') return 'excel.png'
      else if (type === '.docx' || type === '.doc') return 'word.png'
      else if (type === '.pptx') return 'powerpoint.png'
      else if (type === '.rar' || type === '.zip') return 'rar.png'
      else if (type === '.png' || type === '.jpg') return 'pictureIcon.png'
      else return 'document.png'
    },
    removeFile (id) {
      this.selectedFiles.splice(id, 1)
    },
    validateFormData () {
      this.isFormValid = true
      const hasNullValues = Object.values(this.formData).some(value => value === null || value === '')
      if (hasNullValues) {
        this.isFormValid = false
        this.errorMess = 'Thiếu thông tin cần thiết'
        return
      }
      if (!Number.isFinite(this.formData.age) || !Number.isFinite(this.formData.fatherBirthYear) ||
        !Number.isFinite(this.formData.motherBirthYear)) {
        this.isFormValid = false
        this.errorMess = 'Tuổi/Năm sinh không phải là số'
        return
      }
      if (this.formData.citizenIdentificationCard.length > 12) {
        this.isFormValid = false
        this.errorMess = 'Căn cước có tối đa 12 ký tự'
        return
      }
      if (!this.formData.email.includes('@')) {
        this.isFormValid = false
        this.errorMess = 'Email sai định dạng'
        return
      }
      const hasMissingFile = this.fileList.some(x => !x.file)
      if (hasMissingFile) {
        this.isFormValid = false
        this.errorMess = 'Thiếu tài liệu đính kèm'
      }
    },
    async submitFiles () {
      this.isLoading = true
      // Get the reCAPTCHA response token
      const txtCaptcha = window.grecaptcha.getResponse()
      if (!txtCaptcha) {
        this.password = ''
        this.isLoading = false
        this.$showError('Recaptcha Failure, Try Again')
        return
      }

      const filesData = new FormData()

      this.validateFormData()
      if (!this.isFormValid) {
        this.$showError(this.errorMess)
        this.isLoading = false
        return
      }

      const thisYear = new Date().getFullYear()
      this.formData.age = thisYear - Number(this.formData.birthday.split('-')[0])

      this.formData.email = this.formData.email.toLowerCase()
      filesData.append('addApplicationRequestDto', JSON.stringify(this.formData))
      filesData.append('txtCaptcha', txtCaptcha)

      // Append each file to the FormData
      this.fileList.forEach((fileObj) => {
        if (fileObj.file) {
          filesData.append('files', fileObj.file) // Use "Files" as the key\
          filesData.append('type', fileObj.title)
        }
      })

      // for (const [key, value] of filesData.entries()) {
      //   console.log(`${key}:`, value)
      // }

      try {
        await axios.post(this.$store.state.API_Url + 'Applications', filesData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })

        // Reset form data
        this.formData = JSON.parse(JSON.stringify(this.initialFormData))
        this.birthdayInputValue = ''
        this.issueInputValue = ''
        let i = 0
        while (i < 10) {
          this.fileList[i] = { title: this.fileList[i].title, name: '', url: '', extension: '', eg: this.fileList[i].eg, size: '', file: null }
          i++
        }
        this.isLoading = false
        this.modalActives = true
        // this.$showSuccess('Đăng ký thành công')
      } catch (error) {
        this.isLoading = false
        if (error.response.data.error_message) {
          this.$showError(error.response.data.error_message)
        } else {
          this.$showError('Đã xảy ra lỗi không mong muốn')
        }
      }
      window.grecaptcha.reset()
    },
    updateMaxLength () {
      const width = window.innerWidth
      // Adjust maxLength based on width
      if (width <= 436) {
        this.maxLengthTruncated = 12
      } else {
        this.maxLengthTruncated = 20
      }
    },
    async submitForm () {
      this.submitFiles()
      // try {
      //   const response = await axios.post(this.$store.state.API_Url + 'Applications', this.formData)
      //   console.log('Data submitted successfully:', response.data)
      //   alert('Form submitted successfully!')
      // } catch (error) {
      //   console.error('Error submitting form:', error)
      //   alert('An error occurred while submitting the form.')
      // }

      // this.validateForm()

      // if (!this.formIsValid) {
      //   return
      // }
    }
  },

  beforeUnmount () {
    window.removeEventListener('resize', this.updateMaxLength)
    clearInterval(this.intervalId)
  }
}
</script>

<style scoped>
  .ui-content {
    padding: 10px 10px 10px 0px;
    width: 100%;
  }

  .ui-content h3{
    font-weight: bold;
    color: #006884;
    text-transform: uppercase;
    font-size: 28px;
    margin-right: 10px;
  }

  .ui-content .title {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
  }

  /* Form */
  .application-content {
    display: flex;
    justify-content: center;
  }

  .application-content form {
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
    width: 700px;
    background-color: white;
  }

  .form-header {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    width: 100%;
    background: #006884;
    padding: 20px;
    color: white;
    text-align: center;
  }

  .form-header h2 {
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 5px;
  }

  .form-header p {
    font-size: 16px;
    margin-bottom: 5px;
    color: white;
  }

  .form-body {
    padding: 20px;
  }

  .form-body span{
    font-weight: bold;
    font-size: 20px;
  }

  .form-control {
    margin: 0.8rem 0;
    position: relative;
  }

  .muti-data {
    display: flex;
    flex-direction: row;
    gap: 0 20px;
  }

  .data-input {
    flex: 1;
    position: relative;
  }

  .data-input a {
    text-decoration: none;
  }

  .data-input img {
    width: 17px;
    height: 17px;
    margin-right: 3px;
  }

  .data-input-file {
    width: 120px;
  }

  .data-input-file input[type="file"] {
    margin: 0px;
    padding: 0px;
    height: auto;
    display: none;
  }

  .data-input-file label {
    display: inline-block;
    text-transform: uppercase;
    color: #fff;
    background: #0076bb;
    text-align: center;
    padding: 7px;
    font-size: 10px !important;
    letter-spacing: 1.5px;
    user-select: none;
    cursor: pointer;
    border-radius: 3px;
  }

  .data-input-file i {
    margin-right: 5px;
  }

  .data-input-file label:active {
    transform: scale(0.9);
  }

  .formated-date {
    position: absolute;
    top: 37px;
    left: 8px;
    font-size: 18px;
    background-color: white;
    padding: 7px;
  }

  .form-control.invalid input {
    border-color: red;
  }

  .form-control.invalid label {
    color: red;
  }

  .form-control label {
    font-size: 18px;
  }

  .form-control input {
    display: block;
    width: 100%;
    height: 48px;
    font: inherit;
    margin-top: 0.5rem;
    background: transparent;
    border: none;
    outline: none;
    border: 2px solid #ababab;
    border-radius: 5px;
    font-size: 18px;
    color: #424242;
    padding: 10px 0px;
    padding-left: 7px;
  }

  .form-control select {
    display: block;
    width: 100%;
    height: 48px;
    font: inherit;
    margin-top: 0.5rem;
    background: transparent;
    border: none;
    outline: none;
    border: 2px solid #ababab;
    border-radius: 5px;
    font-size: 18px;
    color: #424242;
    padding: 10px 0px;
    padding-left: 7px;
  }

  .birth {
    display: flex;
    justify-items: center;
    align-items: center;
  }

  .birth span {
    margin: 0px 0.5rem;
    margin-top: 0.5rem;
  }

  .form-control-birth #bỉth {
    display: block;
    width: 100%;
    font: inherit;
    margin-top: 0.5rem;
  }

  .files-container {
    padding: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 20px;
    row-gap: 17px;
    width: 100%;
  }

  .file {
    height: 98px;
    overflow: hidden;
    position: relative;
    display: flex;
    justify-content: center;
  }

  .file p{
    margin-top: 5px;
    color: black;
    font-size: 12px;
  }

  .file a {
    text-align: center;
    z-index: 1;
    pointer-events: auto;
    text-decoration: none;
  }

  .close-icon {
    position: absolute;
    right: 0;
    z-index: 2;
    width: 15px;
    height: 19px;
    cursor: pointer;
    pointer-events: auto;
    transition: color 0.3s ease-out;
  }

  .close-icon:hover {
    color: red;
  }

  .application-content button {
    position: relative;
    margin-top: 20px;
    font: inherit;
    border: 1px solid #0076bb;
    background-color: #0076bb;
    color: white;
    cursor: pointer;
    padding: 0.75rem 2rem;
    border-radius: 30px;
  }

  input[type='file'] {
    color: rgba(0, 0, 0, 0);
    border: none;
    padding-left: 0px;
  }

  /* input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }

  input[type="number"] {
      -moz-appearance: textfield;
  } */

  input[type="date"]::-webkit-calendar-picker-indicator {
      cursor: pointer;
      padding: 12px;
  }

  .file-info-box {
    height: 100%;
    width: 310px;
    display: flex;
    align-items: center;
  }

  .file-link {
    display: flex;
    align-items: center;
  }

  .tooltip {
  position: relative;
  display: inline-block;
  margin-left: 10px;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 150px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  left: -40%;
  margin-left: -60px;
  font-size: 14px;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: black transparent transparent transparent;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.mark {
  color: red;
  font-weight: normal !important;
  font-size: 16px !important;
}

.loading .btn-text {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease;
}

.loading::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  pointer-events: none;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: white;
  border-right-color: white;
  animation: loading 1s ease infinite;
}

#date-input {
  border: none;
  outline: none;
  background: transparent;
  position: absolute;
  top: 32px;
  left: 8px;
  font-size: 18px;
  background-color: white;
  width: 120px;
  height: 32px;
  padding: 0px;
}

@keyframes loading {
  0% {
    transform: rotate(0turn);
  }
  100% {
    transform: rotate(1turn);
  }
}

  @media (max-width: 600px) {
    .application-content form {
      width: 400px;
    }

    .muti-data {
      display: block;
    }

    .data-input {
      margin: 0.8rem 0;
    }
  }

  @media (max-width: 435px) {
    .application-content form {
      width: 300px;
    }

    .file-info-box {
      width: 220px;
    }
  }

  @media (max-width: 350px) {
    .application-content form {
      width: 280px;
    }

    .form-control label {
      font-size: 16px;
    }
  }

  @media (max-width: 1080px) {
    .title h3 {
      font-size: 22px;
    }

    .title img {
      width: 180px;
    }
  }

  @media (max-width: 750px) {
    .title img {
      display: none;
    }
  }

</style>
